export default __webpack_public_path__ + "static/22-721cc8145defb963dcc9b1fc4f29d9a9.png";